import { render, staticRenderFns } from "./DeleteCategory.vue?vue&type=template&id=f99b1464"
import script from "./DeleteCategory.vue?vue&type=script&lang=js"
export * from "./DeleteCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports